import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";

export const KnowNutrients = (props) => {
  const data = {
    title: "Do you know what nutrients you have consumed?",
    list: [{
      content: "I do know all the nutrients",
    },{
      content: "I often check the nutrient list",
    },{
      content: "Not really",
    }]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
